// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"3fe0392f","453":"ca7b77d9"}[chunkId] + ".chunk.js";
};